import { useState } from "react";
import { leadWaText, waUrl } from "@/lib/whatsapp";
import { track } from "@/analytics";

const API = process.env.REACT_APP_BACKEND_URL;

export const validateLead = (f, { requireRestaurant = false } = {}) => {
  const e = {};
  if (f.name.trim().length < 2) e.name = "Escribe tu nombre";
  if (f.whatsapp.replace(/\D/g, "").length !== 10) e.whatsapp = "10 dígitos, sin lada +52";
  if (f.city.trim().length < 2) e.city = "¿En qué ciudad estás?";
  if (requireRestaurant && f.restaurant.trim().length < 2) e.restaurant = "Nombre de tu restaurante";
  return e;
};

export const submitLead = async (f, trackEvent) => {
  const payload = {
    name: f.name.trim(),
    whatsapp: f.whatsapp.replace(/\D/g, ""),
    city: f.city.trim(),
    restaurant: (f.restaurant || "").trim(),
    event: f.event || "",
    plan: f.plan || "",
    source: trackEvent,
  };
  const url = waUrl(leadWaText(payload));
  const win = window.open(url, "_blank", "noopener");
  track(trackEvent);
  try {
    await fetch(`${API}/api/leads`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true });
  } catch (err) {
    console.error("lead save failed", err);
  }
  return { url, opened: Boolean(win) };
};

export const useLeadForm = (initial, opts) => {
  const [form, setForm] = useState({ name: "", whatsapp: "", city: "", restaurant: "", plan: "", ...initial });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ sending: false, done: null });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (trackEvent) => {
    const errs = validateLead(form, opts);
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setStatus({ sending: true, done: null });
    const res = await submitLead(form, trackEvent);
    setStatus({ sending: false, done: res });
  };

  const reset = () => { setForm({ name: "", whatsapp: "", city: "", restaurant: "", plan: "", ...initial }); setErrors({}); setStatus({ sending: false, done: null }); };

  return { form, set, setForm, errors, status, submit, reset };
};
